import SniperApp from "./apps/SniperApp";
import AppraisalApp from "./apps/AppraisalApp";
import RecentIntroductionsApp from "./apps/RecentIntroductionsApp";


function getMode() {
  const params = new URLSearchParams(window.location.search);
  return params.get("react_app_mode") || process.env.REACT_APP_MODE || "sniper";
}

export default function App() {
  const mode = getMode();
  if (mode === "appraisal") return <AppraisalApp />;
  if (mode === "introductions" || mode === "recent") return <RecentIntroductionsApp />;
  return <SniperApp />;
}
